/**
 * src/components/directory/Directory.js
 *
 * Componente padre del directorio. Fetchea businesses.json directamente
 * para que el conteo por categoría refleje los datos reales del admin.
 */

import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'
import { signal } from '@core/signal.js'
import { directoryData } from '@/db/directory.db.js'

const isActive = b => {
    if (b.enabled === false) return false
    const now = new Date()
    if (b.activeFrom && new Date(b.activeFrom) > now) return false
    if (b.activeTo   && new Date(b.activeTo)   < now) return false
    return true
}

define('Directory', () => {
    const searchTerm = signal('')
    const onSearch   = term => searchTerm.set(term)

    /* Categorías con conteo reactivo */
    const categoriesSignal = signal(
        directoryData.categories.map(cat => ({ ...cat, count: 0 }))
    )

    fetch(`/data/businesses.json?t=${Date.now()}`)
        .then(r => r.json())
        .then(data => {
            const items = (data.items || []).filter(isActive)
            categoriesSignal.set(
                directoryData.categories.map(cat => ({
                    ...cat,
                    count: items.filter(b => b.categorySlug === cat.slug).length
                }))
            )
        })
        .catch(() => {})

    return h('section', { className: 'directory' },
        h('div', { className: 'directory__inner' },
            c('DirectoryHeader', { ...directoryData.section, onSearch }),
            c('CategoryGrid', { categories: categoriesSignal, searchTerm })
        )
    )
})
